import { getIndustryList } from '@/api/operator/cgi/smb/account/gdt';
import { getIndustryList as getIndustryListByType } from '@/pages/agency/task/dashboard/api';
import { getIndustryTeamList, getRuyiIndustryList, getCategoryList, getOptimizationGoalList } from '@/pages/agency/growup/dashboard/api';
import { getIndustry } from '@/pages/agency/utils/industry';
import { BOOL_LIST } from './constants';

export default {
  below_score_type: {
    name: 'below_score_type',
    title: '待提升客户',
    type: 'select',
    defaultValue: '',
    config: {
      data: [{
        value: '',
        label: '全部',
      }],
      placeholder: '待提升客户',
    },
    clearable: true,
  },
  first_industry_name: {
    name: 'first_industry_name',
    title: '行业',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      search: true,
      data: [],
      placeholder: '请选择行业',
      fetchData: (params: any) => getIndustryList({ data: params }),
      convertData: (res: any) => {
        const list = res?.data?.list?.filter((v: any) => v.level === 1 && v.status !== 'deprecated').map((v: any) => ({
          value: v.industry_name,
          label: v.industry_name,
        }));
        return list || [];
      },
    },
  },
  industry_name_level2: {
    name: 'industry_name_level2',
    title: '二级行业',
    type: 'select-tree',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      useLocalSearch: true,
      search: true,
      TreeProps: {
        checkAll: true,
        setBranchCheckAll: (index: number) => (index === 1),
      },
      selectTarget: 'child',
      data: [],
      placeholder: '二级行业',
      fetchData: (params: any) => getIndustryList({ data: params }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return getIndustry(list, true, 'industry_name');
        }
        return [];
      },
    },
  },
  // 某个一级行业下的二级行业
  industry_name_level2_of_first: {
    name: 'industry_name_level2',
    title: '二级行业',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      search: true,
      data: [],
      placeholder: '请选择',
      fetchData: (params: any) => getIndustryList({ data: params }),
      convertData: (res: any, params: any) => {
        const { code, data = {} } = res;
        const { industry_name_level1 } = params || {};
        if (code === 0) {
          const { list = [] } = data;
          const tree = getIndustry(list, true, 'industry_name');
          const level2List = tree.find((v: any) => v.desc === industry_name_level1)?.options?.map((v: any) => ({
            ...v,
            label: v.desc,
          }));
          return level2List;
        }
        return [];
      },
    },
  },
  industry_name: {
    name: 'industry_name',
    title: '行业',
    type: 'select-tree',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      useLocalSearch: true,
      search: true,
      data: [],
      placeholder: '行业',
      fetchData: (params: any) => getIndustryList({ data: params }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return getIndustry(list, true, 'industry_name', (child: any, parent: any) => ({
            ...child,
            value: `${parent.desc}_${child.desc}`,
          }));
        }
        return [];
      },
    },
  },
  industry_name_with_all: {
    name: 'industry',
    title: '行业',
    type: 'select-tree',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      useLocalSearch: true,
      search: true,
      data: [],
      placeholder: '请选择',
      fetchData: (params: any) => getIndustryList({ data: params }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          const industryList = getIndustry(list, true, 'industry_name', (child: any, parent: any) => ({
            ...child,
            value: `${parent.desc}_${child.desc}`,
          }));
          industryList.unshift({ value: '全行业', desc: '全行业' });
          return industryList;
        }
        return [];
      },
    },
  },
  kpi_industry_name: {
    name: 'industry_name',
    title: '行业',
    type: 'select-tree',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      useLocalSearch: true,
      search: true,
      data: [],
      placeholder: '行业',
      fetchData: () => getIndustryListByType({ type: 2 }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return getIndustry(list, true, 'name', (child: any, parent: any) => ({
            ...child,
            value: `${parent.desc}_${child.desc}`,
          })).map((v) => {
            if (v.value.includes('SVIP')) {
              return {
                ...v,
                options: [],
              };
            }
            return v;
          });
        }
        return [];
      },
    },
  },
  industry_team: {
    name: 'first_industry_name',
    title: '行业',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      search: true,
      data: [],
      placeholder: '行业',
      fetchData: () => getIndustryTeamList(),
      convertData: (res: any) => {
        const list = res?.data?.list?.map((v: string) => ({
          value: v,
          label: v,
        }));
        return list || [];
      },
    },
  },
  industry_for_business: {
    name: 'industry_for_business',
    title: '腰客行业',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      search: true,
      data: [],
      placeholder: '腰客行业',
    },
  },
  advertiser_policy_area: {
    name: 'advertiser_policy_area',
    title: '政策行业',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      search: true,
      data: [],
      placeholder: '政策行业',
    },
  },
  partition_time: {
    name: 'partition_time',
    title: '时间',
    type: 'date-picker',
    config: {
      type: 'range',
      useNewUI: true,
      useShortcut: false,
      horizontalPosition: 'right',
    },
    clearable: false,
  },
  ability_filters: {
    name: 'filters',
    title: '筛选',
    type: 'select',
    config: {
      clear: true,
      data: [],
      placeholder: '筛选',
    },
  },
  lag: {
    name: 'lag',
    title: '是否落后',
    type: 'select',
    config: {
      clear: true,
      data: [
        { value: 1, label: '是' },
        { value: 0, label: '否' },
      ],
      placeholder: '是否落后',
    },
  },
  ru_yi_industry: {
    name: 'ru_yi_industry',
    title: '如翼行业',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      search: true,
      data: [],
      placeholder: '如翼行业',
      fetchData: () => getRuyiIndustryList(),
      convertData: (res: any) => {
        const list = res?.data?.list?.map((v: string) => ({
          value: v,
          label: v,
        }));
        return list || [];
      },
    },
  },
  ru_yi_brand_name: {
    name: 'ru_yi_brand_name',
    title: '如翼品牌名称',
    type: 'search',
    config: {
      placeholder: '如翼品牌名称',
    },
  },
  brand_auth_status: {
    name: 'brand_auth_status',
    title: '品牌是否授权',
    type: 'select',
    config: {
      clear: true,
      data: [],
      placeholder: '品牌是否授权',
    },
  },
  crowd: {
    name: 'crowd',
    title: '人群',
    type: 'select',
    config: {
      clear: true,
      data: [],
      placeholder: '人群',
    },
  },
  cert_cate: {
    name: 'cert_cate',
    title: '认证类型',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '认证类型',
    },
  },
  cert_level: {
    name: 'cert_level',
    title: '认证级别',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '认证级别',
    },
  },
  category: {
    name: 'category',
    title: '岗位',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '岗位',
    },
  },
  weeks_of_quarter: {
    name: 'weekday',
    title: '数据周期',
    type: 'date-picker',
    config: {
      picker: 'week',
      type: 'single',
      useNewUi: true,
      clear: true,
      placeholder: '请选择自然周',
    },
    clearable: true,
  },
  weeks_of_quarter_range: {
    name: 'weekday_range',
    title: '数据周期',
    type: 'date-picker',
    config: {
      picker: 'week',
      type: 'range',
      useNewUi: true,
      clear: true,
      placeholder: '请选择自然周',
    },
    clearable: true,
  },
  ams_cate_all_v2: {
    name: 'ams_cate_all_v2',
    title: '类目名称',
    type: 'select',
    config: {
      clear: true,
      search: true,
      data: [],
      placeholder: '类目名称',
      fetchData: () => getCategoryList(),
      convertData: (res: any) => {
        const list = res?.data?.list?.map((v: string) => ({
          value: v,
          label: v,
        }));
        return list || [];
      },
    },
  },
  interest_type: {
    name: 'type',
    title: '激励类型',
    type: 'select',
    config: {
      clear: true,
      data: [
        { value: 1, label: '行业扶持' },
        { value: 2, label: '政策激励' },
      ],
      placeholder: '请选择',
    },
  },
  indicator_sort: {
    name: 'order_type',
    title: '排序方式',
    type: 'select',
    defaultValue: 1,
    config: {
      data: [
        { value: 1, label: '默认排序' },
        { value: 2, label: '达成率降序' },
        { value: 3, label: '达成率升序' },
      ],
    },
  },
  zc_advertiser_group: {
    name: 'zc_advertiser_group',
    title: '客户政策集团',
    type: 'search',
    config: {
      placeholder: '搜索客户政策集团',
    },
  },
  short_advertiser_name: {
    name: 'short_advertiser_name',
    title: '客户简称',
    type: 'search',
    config: {
      placeholder: '搜索客户简称',
    },
  },
  is_iap_game: {
    name: 'is_iap_game',
    title: '是否IAP游戏',
    type: 'select',
    config: {
      clear: true,
      placeholder: '是否IAP游戏',
      data: BOOL_LIST,
    },
  },
  attention: {
    name: 'attention',
    title: '是否重点关注',
    type: 'select',
    config: {
      clear: true,
      placeholder: '是否重点关注',
      data: BOOL_LIST,
    },
  },
  optimization_goal: {
    name: 'optimization_goal',
    title: '浅层优化目标',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      clear: true,
      search: true,
      data: [],
      placeholder: '浅层优化目标',
      fetchData: () => getOptimizationGoalList(),
      convertData: (res: any) => {
        return res?.data?.list || [];
      },
    },
  },
  city_star_track: {
    name: 'city_star_track',
    title: '城市之星赛道',
    type: 'search',
    config: {
      placeholder: '城市之星赛道',
    },
  },
  partner_level: {
    name: 'partner_level',
    title: '城市合伙人级别',
    type: 'select',
    config: {
      clear: true,
      data: [],
      placeholder: '城市合伙人级别',
    },
  },
  promotion_time: {
    name: 'promotion_time',
    title: '合伙人晋升时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      picker: 'month',
      format: 'XXXX-XX',
      showFormat: 'XXXX-XX',
      optionalStartRelativeDays: -9999,
      placeholder: '合伙人晋升时间',
      clear: true,
    },
  },
  merchants_item_rename: {
    name: 'merchants_item_rename',
    title: '项目标签',
    type: 'search',
    config: {
      placeholder: '搜索项目标签',
    },
  },
  is_qtd_big_customer: {
    name: 'is_qtd_big_customer',
    title: '是否季度内大客户',
    type: 'select',
    config: {
      clear: true,
      placeholder: '是否季度内大客户',
      data: BOOL_LIST,
    },
  },
  mid_customer: {
    name: 'mid_customer',
    title: '是否季度内中长尾客户',
    type: 'select',
    config: {
      clear: true,
      placeholder: '是否季度内中长尾客户',
      data: BOOL_LIST,
    },
  },
  customer_weight: {
    name: 'customer_weight',
    title: '客户权重',
    type: 'select',
    config: {
      clear: true,
      placeholder: '客户权重系数',
      data: [
        { value: 1, label: '1' },
        { value: 2, label: '2' },
      ],
    },
  },
  customer_value_weight: {
    name: 'customer_value_weight',
    title: '客户价值系数',
    type: 'select',
    config: {
      clear: true,
      placeholder: '客户价值系数',
      data: [
        { value: 1, label: '1' },
        { value: 3, label: '3' },
        { value: 6, label: '6' },
      ],
    },
  },
};
